<vs-dialog [config]="{ dialogContainerClass: 'w-[450px]' }">
  <vs-dialog-header
    [config]="{ mode: 'simple', showDivider: true, icon: 'check-circle', iconTheme: 'primary', title: prompt?.title ?? '' }"
  ></vs-dialog-header>

  <div class="p-4">
    <vs-form-field [config]="{ label: prompt?.label ?? '' }">
      <textarea vsInput [formControl]="note" [placeholder]="prompt?.placeholder ?? ''"></textarea>
    </vs-form-field>
  </div>

  <div class="flex justify-end gap-2 px-4 pb-4">
    <button vs-button appearance="outline" (click)="close()">{{ config.noteDialog.back }}</button>
    <button vs-button theme="primary" [disabled]="!canConfirm()" (click)="confirm()">{{ prompt?.save }}</button>
  </div>
</vs-dialog>
